import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useCommunityTasks } from '../state/hooks';
import useFeedbackFilters from '../../hooks/useFeedbackFilters';
import { getPaginationConfig } from './paginationUtils';
import FeedbackPageLayout from './FeedbackPageLayout';

function FeedbackProvider() {
  const [isShowMenu, setShowMenu] = useState(false);
  
  const location = useLocation();
  const pathName = location.pathname;

  const {
    selectedYear,
    selectedState,
    selectedDocumentType,
    selectedSubject,
    selectedResponseType,
    sortItem,
    currentPage,
    filterConfig,
    handleFilterChange,
    setSortItem,
    handlePageChange,
    resetFilters,
  } = useFeedbackFilters();

  const communityTasksFilterConfig = {
    ...filterConfig,
    sortBy: 'requestedAt',
  };

  const {
    data: communityTasksResponse,
    isLoadingdata: isLoadingCommunityTasks,
    isFetching: isFetchingCommunityTasks,
  } = useCommunityTasks(communityTasksFilterConfig);

  useEffect(() => {
    if (location.pathname === '/giveFeedback') {
      resetFilters();
    }
  }, [location.pathname]);

  const paginationConfig = getPaginationConfig(communityTasksResponse, communityTasksFilterConfig.size);

  const getFeedbackList = () => communityTasksResponse?.content || [];

  return (
    <FeedbackPageLayout
      isShowMenu={isShowMenu}
      setShowMenu={setShowMenu}
      selectedYear={selectedYear}
      selectedState={selectedState}
      selectedDocumentType={selectedDocumentType}
      selectedSubject={selectedSubject}
      selectedResponseType={selectedResponseType}
      sortItem={sortItem}
      handleFilterChange={handleFilterChange}
      setSortItem={setSortItem}
      feedbackList={getFeedbackList()}
      pathName={pathName}
      showPagination={true}
      paginationConfig={paginationConfig}
      currentPage={currentPage}
      onPageChange={handlePageChange}
      isPaginationLoading={isLoadingCommunityTasks}
      isLoading={isLoadingCommunityTasks || isFetchingCommunityTasks}
    />
  );
}

export default FeedbackProvider;